import {init} from '../../../orejime/dist/orejime.js';
import '../../sass/orejime.scss';

const logo = getComputedStyle(document.documentElement).getPropertyValue('--background-main-logo')
    .replace('url(', '').replace(')', '').replace('//', '/').replace('/.', '.').trim().split("\\").join("");
const orejimeConfig = {
    elementID: 'moodal-consent',
    appElement: '#main-container',
    cookieName: 'COOKIE_CONSENT',
    cookieExpiresAfterDays: 365,
    stringifyCookie: contents => JSON.stringify(contents),
    parseCookie: cookie => JSON.parse(cookie),
    privacyPolicy: '/static/cookies',
    default: false,
    mustConsent: false,
    mustNotice: true,
    logo: logo,
    debug: false,
    translations: {
        fr: {

            consentModal: {
                title: '',
                description: 'Avec votre accord, nous et nos partenaires utilisons des cookies.',
                privacyPolicy: {
                    name: 'politique de confidentialité',
                    text: 'Pour en savoir plus, merci de lire notre {privacyPolicy}.',
                }
            },
            consentNotice: {
                changeDescription: 'Des modifications ont eu lieu depuis votre dernière visite, merci de mettre à jour votre consentement.',
                description: 'UniversCiné utilise des cookies afin de vous offrir une expérience utilisateur optimale.</br></br> En les acceptant vous nous permettez d’améliorer nos services, de mesurer notre audience, de personnaliser votre expérience et vous pourrez bénéficier des fonctionnalités relatives aux réseaux sociaux.</br></br>',
                learnMore: 'Personnaliser',
                privacyPolicy: {
                    name: 'politique de gestion des cookies',
                    text: 'Vous pouvez personnaliser vos choix en cliquant sur « <strong>PERSONNALISER</strong> » et obtenir davantage d\'informations en consultant notre <a href="/static/cookies">politique de gestion des cookies</a>.',
                }
            },
            accept: 'Accepter',
            acceptTitle: 'Accepter les cookies',
            acceptAll: 'Tout accepter',
            save: 'Confirmer la sélection',
            saveData: 'Sauvegarder ma configuration sur les informations collectées',
            decline: 'Continuer sans accepter',
            declineAll: 'Tout refuser',
            close: 'Fermer',
            enabled: 'Activé',
            disabled: 'Désactivé',
            app: {
                optOut: {
                    title: '(opt-out)',
                    description: 'Cette application est chargée par défaut (mais vous pouvez la désactiver)',
                },
                required: {
                    title: '- Requis',
                    description: 'Cette application est toujours requise',
                },
                purposes: 'En savoir plus',
                purpose: 'En savoir plus',
            },
            poweredBy: '',
            newWindow: 'nouvelle fenêtre',
        },
    },
    apps: [
        {
            name: 'technical-cookies',
            title: 'Techniques',
            description: 'Ces cookies assurent le bon fonctionnement de notre site UniversCiné et ne peuvent donc pas être désactivés. Ils sont principalement destinés à améliorer votre expérience en conservant des actions que vous avez effectuées.',
            cookies: [
                'COOKIE_CONSENT',
                'PHPSESSID',
                'showedPopupSvod',
                'REMEMBERME',
                'device_view',
                'universe',
                'deviceKey',
                'creditCardWarningClosed',
                'episodeSynopsis',
            ],
            purposes: [],
            required: true,
            default: true,
            optOut: true,
        },
        {
            name: 'analytics',
            title: 'Mesure d\'audience',
            description: 'Ces cookies nous permettent d’améliorer l’ergonomie du site en recueillant des statistiques de fréquentation et d’utilisation. Vous pouvez les désactiver mais cela pourrait avoir un impact négatif sur votre expérience de navigation.\n',
            cookies: [
            ],
            purposes: [
                "Google Analytics : Permet d'analyser les statistiques de fréquentation de notre site.",
            ],
            required: false,
        },
        {
            name: 'ads',
            title: 'Publicités',
            description: 'Nous n’utilisons pas de publicité sur UniversCiné. En revanche, nous utilisons des cookies à visée publicitaire afin d\'adapter et limiter les publicités de notre service que vous verrez sur les réseaux sociaux et d\'autres sites web.\n',
            cookies: [
                '_fbp',
            ],
            purposes: [
                "Pixel Facebook : Permet d'identifier le visiteur en provenance d'une publication facebook.",
                "Google Ads : Permet d'identifier le visiteur et de lui proposer des publicités personnalisées d'UniversCiné sur des sites tiers (via les emplacements Google)",
                "AppNexus : Permet d'identifier le visiteur et de lui proposer des publicités personnalisées d'UniversCiné sur des sites tiers",
            ],
            required: false,
        },
    ],
};

document.addEventListener('DOMContentLoaded', function () {
    const mainContainer = document.querySelector('#main-container');
    if (mainContainer) {
        const orejime = init(orejimeConfig);
        let linkCookies = document.querySelector('#link-cookies');
        if(linkCookies) {
            document.querySelector('#link-cookies').addEventListener('click', function (e) {
                e.preventDefault();
                orejime.show();
            }, false);
        }
    }
});
